<template>
  <div class="login-form">
    <v-snackbar
      v-model="show"
      top
      right
      :color="notification.color"
    >
      {{ notification.message }}

      <template #action="{ attrs }">
        <v-btn
          color="white"
          icon
          v-bind="attrs"
          @click="show = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-form
      ref="form"
      @submit.prevent="submit"
    >
      <v-card
        class="rounded-0"
        style="box-shadow: 2px 2px 4px 0px #2a3244 !important;"
      >
        <v-col class="col-12 text-center text-uppercase font-weight-bold btn-bg-gunmetal py-5">
          {{ productName }}
        </v-col>
      </v-card>
      <v-card
        class="mx-auto pa-5"
        outlined
        tile
        elevation="6"
      >
        <v-card-title class="my-1 py-7">
          <v-img
            contain
            height="38px"
            position="center"
            src="/src/assets/hyphen/logo.png"
          />
        </v-card-title>

        <v-card-text
          v-if="!resetPasswordSuccessful"
          class="mt-6 pb-0"
        >
          <p>
            Enter your new passsword
          </p>
          <v-alert
            v-if="formError"
            color="red"
            type="error"
          >
            {{ formError }}
          </v-alert>
          <v-text-field
            v-model="password"
            prepend-inner-icon="mdi-lock"
            height="70px"
            outlined
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="showPassword ? 'text' : 'password'"
            name="input-10-2"
            label="Password"
            hint="At least 12 characters"
            class="input-group--focused"
            @click:append="showPassword = !showPassword"
          />
          <v-text-field
            v-model="passwordConfirmation"
            prepend-inner-icon="mdi-lock-alert"
            height="70px"
            outlined
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="showPassword ? 'text' : 'password'"
            name="input-10-2"
            label="Password Confirmation"
            hint="At least 8 characters"
            class="input-group--focused"
            @click:append="showPassword = !showPassword"
          />
        </v-card-text>
        <v-card-text v-else>
          <p>
            Reset Password was successful.
          </p>
          <p>
            Thank you.
          </p>
        </v-card-text>

        <v-card-actions class="mb-3 px-4">
          <v-btn
            v-if="!resetPasswordSuccessful"
            type="submit"
            color="primary"
            large
            block
            :loading="formProcessing"
            :icon="formProcessing"
          >
            <v-icon
              light
              left
            >
              mdi-lock-reset
            </v-icon> Reset Password
          </v-btn>
          <v-btn
            v-else
            color="primary"
            large
            block
            to="{ name: 'login'}"
          >
            Ok
          </v-btn>
        </v-card-actions>
        <div class="text-center">
          <span class="text-caption font-weight-thin text-center">{{ version }}</span>
        </div>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';
import {
  mapActions,
  mapGetters,
  mapState,
} from 'vuex';

export default {
  setup() { return { v$: useVuelidate() }; },
  data() {
    return {
      email: '',
      token: '',
      password: '',
      passwordConfirmation: '',
      resetPasswordSuccessful: false,
      formError: '',
      formProcessing: false,
      showPassword: false,
      rules: {
        required: (value) => !!value || 'Required.',
        min: (v) => v.length >= 12 || 'Password must be at least 12 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
    };
  },
  computed: {
    ...mapState('notification', ['notification']),
    ...mapGetters('app', ['assetPath', 'version', 'name', 'brandName']),
    ...mapGetters('settings', ['productName']),
  },
  watch: {
    notification(value) {
      this.show = value;
    },
  },
  validations: {
    email: { required, email },
  },
  mounted() {
    this.email = this.$route.query.email;
    this.token = this.$route.query.token;
  },

  methods: {
    ...mapActions('currentUser', ['logUserIn']),
    async submit() {
      if (!this.checkFormErrors()) {
        this.setFormState();
        try {
          await this.$axios.get('/sanctum/csrf-cookie');
          await this.$axios.post('/api/reset-password', {
            email: this.email,
            token: this.token,
            password: this.password,
            password_confirmation: this.passwordConfirmation,
          });

          this.setFormState(true);
          this.resetPasswordSuccessful = true;
        } catch (error) {
          if (error.response.data.errors) {
            const errors = Object.keys(error.response.data.errors)
              .map((e) => error.response.data.errors[e]);
            this.setFormState(
              false,
              String(errors[0]),
            );
          } else {
            this.setFormState(
              false,
              error.response.data.message,
            );
          }
        }
      }
    },
    setFormState(processing = true, message = '') {
      this.formProcessing = processing;
      this.formError = message;
    },
    checkFormErrors() {
      let error;
      if (!this.v$.email.$dirty) {
        error = false;
      }
      if (!this.v$.email.email) {
        this.formError = 'Must be valid e-mail';
        error = true;
      }
      if (!this.v$.email.email) {
        this.formError = 'E-mail is required';
        error = true;
      }
      return error;
    },
    resetForm() {
      this.email = '';
    },
  },
};
</script>

<style>
.login-form {
  /*max-width: 480px;*/
  max-width: 35vw;
  margin-bottom: 15vh;
}
.login-form .v-card {
  box-shadow: 2px 2px 4px 0px grey !important;
}
.login-form .v-btn.primary {
  background-color: #205e86 !important;
  height: 3.5rem !important;
  font-size: 1.1rem !important;
  font-weight: 800;
}
.login-form .v-btn.primary .v-icon {
  font-size: 2.2rem !important;
  font-weight: 400 !important;
  margin-right: 1rem;
  -webkit-text-stroke: 1px #205e86;
}
.login-form .v-input__icon {
  width: 40px;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
}
.login-form .v-input__icon .v-icon.v-icon {
  color: #4d4d4d;
  font-size: 2rem;
  -webkit-text-stroke: 1px #ffffff;
}
.login-form .v-input .v-label {
  padding: 0.5rem 1rem;
  height: auto;
}
.login-form .v-label--active {
  padding: 0rem 1rem !important;
}
.login-form .v-input input {
  padding: 0rem 1rem;
  background-color: #e9eaec;
  min-height: 45px !important;
  max-height: 50px;
}
.login-form .v-input__slot {
  background: transparent !important;
}
.brand-text {
  text-transform: capitalize;
}
</style>
